const STORAGE_KEY = 'inboxpulse_message_collection_v1';

export function loadCollection() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const data = JSON.parse(raw);
    return Array.isArray(data) ? data : [];
  } catch {
    return [];
  }
}

export function persistCollection(items) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
}

export function collectionItemKey(sessionId, emailId) {
  return `${sessionId}:${emailId}`;
}
